import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';

import { useEventListener } from './hooks/useEventListener';

export const AppHooks = () => {
	const { loading, productCardView } = useSelector((state) => state);

	const [loadableUpdate, setLoadableUpdate] = useState(0);

	const [width, setWidth] = useState(window.innerWidth);
	const [rootMargin, setRootMargin] = useState('100%');

	useEventListener('resize', () => {
		setWidth(window.innerWidth);
	});

	useEventListener('load', () => {
		setRootMargin('300%');
	});

	useEventListener('loadable-component-loaded', () => {
		setLoadableUpdate(Math.random());
	});

	const { DisableLazyLoad } = useSelector((state) => state.featureSwitches);

	const intersectionObserver = useRef(
		!DisableLazyLoad
			? new IntersectionObserver(
					(entries) => {
						const intersected = entries.filter((entry) => entry.isIntersecting);

						intersected.forEach(({ target }) => {
							const id = target.dataset.lazySku;

							window.dispatchEvent(new CustomEvent(`lazy-load-${id}`));

							intersectionObserver.current.unobserve(target);
						});
					},
					{ rootMargin, threshold: 0.2 }
			  )
			: false
	);

	useEffect(() => {
		const observer = intersectionObserver.current;

		const getLazyAsset = (func) => {
			document.querySelectorAll('[data-lazy-sku]').forEach(func);
		};

		if (!DisableLazyLoad) {
			getLazyAsset((lazyAsset) => observer.observe(lazyAsset));
		}

		return () => {
			if (!DisableLazyLoad) {
				getLazyAsset((lazyAsset) => observer.unobserve(lazyAsset));
			}
		};
	}, [loading, productCardView, width, DisableLazyLoad, loadableUpdate]);
	return null;
};

export default AppHooks;
